import { render, staticRenderFns } from "./DatosMembresia.vue?vue&type=template&id=7c0e6ff8"
import script from "./DatosMembresia.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosMembresia.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports